import popStarsAdvertisement from './popStarsAdvertisement.json'

export interface HomePromotion {
  id: string
  theme: 'pop-stars' | 'edit' | 'higgsfield'
  disclosure: string
  eyebrow: string
  headline: string
  body: string
  image: string
  imageAlt: string
  imageWidth: number
  imageHeight: number
  imageCredit?: string
  releaseDate?: string
  releaseLine?: string
  action: string
  destination: string
  affiliateDisclosure?: string
}

// Explicit placements keep every approved campaign visible; these are not news stories.
export const homePromotions: readonly HomePromotion[] = [
  popStarsAdvertisement as HomePromotion,
  {
    id: 'omikina-edit-october-2026',
    theme: 'edit',
    disclosure: 'House advertisement · OMIKINA EDIT',
    eyebrow: 'OCTOBER 2026 · Nº002',
    headline: 'A change of texture.',
    body: 'Seven stories on texture and self-expression: soft layers, sharp chrome, a little plum.',
    image: '/advertising/2026-10/edit-october.webp',
    imageAlt: 'Layered charcoal tailoring and a plum knit in a sunlit stone interior.',
    imageWidth: 1536,
    imageHeight: 1024,
    imageCredit: 'AI-generated editorial concept · ChatGPT',
    action: 'Read the October issue',
    destination: 'https://edit.omikina.com/#edition/2026-10',
  },
  {
    id: 'higgsfield-john-e4340f',
    theme: 'higgsfield',
    disclosure: 'Affiliate advertisement',
    eyebrow: 'HIGGSFIELD · AI CREATIVE TOOLS',
    headline: 'Make your next idea move.',
    body: 'Explore AI image and video tools with Higgsfield. Your next creative experiment starts here.',
    image: '/advertising/2026-10/higgsfield-creative-tools.svg',
    imageAlt: 'Original vector illustration of luminous image frames becoming a motion sequence.',
    imageWidth: 1600,
    imageHeight: 900,
    action: 'Explore Higgsfield',
    destination: 'https://higgsfield.ai?fpr=john-e4340f',
    affiliateDisclosure: 'John N. Farmer may earn a commission if you purchase through this link.',
  },
]

export function promotionReleaseLine(promotion: HomePromotion, now = new Date()): string | undefined {
  if (!promotion.releaseDate || !promotion.releaseLine) return undefined
  const chicagoDate = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(now)
  // On the release date, retain the announced date without claiming a release was verified.
  return chicagoDate < promotion.releaseDate ? promotion.releaseLine : 'October 16, 2026'
}
